import { DEFAULT_SELLER_NUMBER } from '../constants'

export default function isProductMKT(sellerIdentifier: string) {
  const productMKTValidation = sellerIdentifier !== DEFAULT_SELLER_NUMBER

  return productMKTValidation
}
